export default class Account {


    constructor(){

    }

    firstName = "";
    lastName = "";
    email = "";
    phone = "";
    password = "";
    confirmPassword = "";
    businessName = "";
   
    
    street = "";
    village = "";
    city = "";
    province = "";
    region = "";   
    zip = "";

    legalForm = ""; 
    sSNCompany = "";
    vat = "";
    pec = "";
    uniqueCode = "";
    
    attorneyFirstName = "";
    attorneyLastName = "";
    
    attorneyMunicipality = "";
    attorneyCity = "";
    attorneyProvince = "";
    attorneyRegion = "";
    attorneyZip = "";
    attorneySSN = "";
    attorneyIDCardType;
    attorneyIDCardExpiryDate;   
    attorneyIDCardNumber;
    attorneyIDCardIssuingAuthority;
    sponsor = "";
    geomSoldi = "";
   
}